import { REGISTRATION_DATA, REGISTER_BUSINESS_SUCCESS, REGISTER_BUSINESS_FAIL } from '../types';

const initialState = [];

const registrationReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case REGISTRATION_DATA:
      return payload;
    case REGISTER_BUSINESS_SUCCESS:
      return {
        ...state,
        // data: payload,
      };
    case REGISTER_BUSINESS_FAIL:
      return {
        ...state,
        // data: payload,
      };
    default:
      return state;
  }
};

export default registrationReducer;
